import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { IDriveContent } from 'src/@types/drive';
import {
  DriveRequests,
  type DriveUpdateFavoritePayload,
} from 'src/requests/drive';
import { QueryKey } from 'src/utils/react-query';

export const useFavoriteContentMutation = () => {
  const queryClient = useQueryClient();

  const { mutateAsync: setFavorite, isLoading: isFavoriteLoading } =
    useMutation(
      async ({ id, isFavorited }: DriveUpdateFavoritePayload) =>
        DriveRequests.updateFavorite({ id, isFavorited }),
      {
        onSuccess(updatedContent) {
          queryClient.setQueryData<IDriveContent[]>(
            [QueryKey.DRIVE, updatedContent?.parent || ''],
            (contents) =>
              contents?.map((content: IDriveContent) =>
                content._id === updatedContent._id
                  ? { ...content, ...updatedContent }
                  : content,
              ),
          );
        },
      },
    );

  return {
    setFavorite,
    isFavoriteLoading,
  };
};
